import PropTypes from 'prop-types';
import { cva } from 'class-variance-authority';

const skeletonStyles = cva('bg-gray-200 animate-pulse', {
    variants: {
        variant: {
            text: 'h-4 rounded-sm',
            circle: 'rounded-full aspect-square',
            rectangular: 'h-11 rounded-sm',
            rounded: 'rounded-md',
            square: 'aspect-square rounded-sm',
        },
    },
    defaultVariants: {
        variant: 'text',
    },
});

const Skeleton = ({ className, variant, width, height }) => {
    return <div className={skeletonStyles({ variant, width, height, className })} style={{ width, height }} />;
};

Skeleton.propTypes = {
    className: PropTypes.string,
    variant: PropTypes.oneOf(['text', 'circle', 'rectangular', 'rounded', 'square']),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Skeleton;
